/**
 * @generated SignedSource<<885c4c92ff842e34de47c67034441569>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TodoPriority = "DEFAULT" | "HIGH" | "LOW" | "URGENT";
export type WorkspaceTodoEditMainSubTodosSaveNewOrderMutation$variables = {
  id: string;
  newOrder: ReadonlyArray<string>;
};
export type WorkspaceTodoEditMainSubTodosSaveNewOrderMutation$data = {
  readonly todoWorkspace: {
    readonly updateSubTodoOrder: {
      readonly id: string;
      readonly subWorkspaceTodos: ReadonlyArray<{
        readonly id: string;
        readonly priority: TodoPriority;
        readonly title: string;
      }> | null;
    };
  };
};
export type WorkspaceTodoEditMainSubTodosSaveNewOrderMutation$rawResponse = {
  readonly todoWorkspace: {
    readonly updateSubTodoOrder: {
      readonly id: string;
      readonly subWorkspaceTodos: ReadonlyArray<{
        readonly id: string;
        readonly priority: TodoPriority;
        readonly title: string;
      }> | null;
    };
  };
};
export type WorkspaceTodoEditMainSubTodosSaveNewOrderMutation = {
  rawResponse: WorkspaceTodoEditMainSubTodosSaveNewOrderMutation$rawResponse;
  response: WorkspaceTodoEditMainSubTodosSaveNewOrderMutation$data;
  variables: WorkspaceTodoEditMainSubTodosSaveNewOrderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "newOrder"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "TodoWorkspaceMutation",
    "kind": "LinkedField",
    "name": "todoWorkspace",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "newSubTodoOrder",
            "variableName": "newOrder"
          }
        ],
        "concreteType": "TodoWorkspace",
        "kind": "LinkedField",
        "name": "updateSubTodoOrder",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "subWorkspaceTodos",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "priority",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceTodoEditMainSubTodosSaveNewOrderMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceTodoEditMainSubTodosSaveNewOrderMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "5a983ccc07dfd886360cecd64a280d64",
    "id": null,
    "metadata": {},
    "name": "WorkspaceTodoEditMainSubTodosSaveNewOrderMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceTodoEditMainSubTodosSaveNewOrderMutation(\n  $id: ID!\n  $newOrder: [String!]!\n) {\n  todoWorkspace(id: $id) {\n    updateSubTodoOrder(newSubTodoOrder: $newOrder) {\n      id\n      subWorkspaceTodos {\n        id\n        title\n        priority\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "03efada1cf67a3d3f21c81850ea1ac43";

export default node;
